import { InvoiceTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1963. 請求タスクコメント削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/invoice_task_comments/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
};

const deleteInvoiceTaskComment = (props: Props): Promise<InvoiceTaskComment> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/invoice_task_comments/${props.id}`
  );
};

export const useDeleteInvoiceTaskComment = () => {
  return useMutation({
    mutationFn: deleteInvoiceTaskComment,
  });
};
